import React from 'react';
import { render } from './render';
const content = (children, plugins, options)=>React.Children.map(children, (child)=>{
        if (typeof child === 'string') {
            return render(child, plugins, options);
        }
        return child;
    });
const Component = ({ container = 'span', componentProps = {}, children, plugins = [], options = {} })=>React.createElement(container, componentProps, content(children, plugins, options));
export default Component;
